import axios from "axios";

const URL_BUSCAR = "/api/pipeline/Integracoes/BuscarToken";

export const getExactToken = async () => axios.post(URL_BUSCAR);
